import { SpeakerStatus } from '@core/types';
import { useTranslation } from 'react-i18next';

// Mirrors the backend SpeakerStatus flow order (see @core/types speaker.ts). Every value is mapped
// so a switch/lookup miss can't silently render a blank badge if the backend ever sends a later-phase status.
const STATUS_LABEL_KEYS: Record<SpeakerStatus, string> = {
    [SpeakerStatus.Offline]: 'Speaker.Status.Offline',
    [SpeakerStatus.SettingUp]: 'Speaker.Status.SettingUp',
    [SpeakerStatus.AwaitingAdmission]: 'Speaker.Status.AwaitingAdmission',
    [SpeakerStatus.Connecting]: 'Speaker.Status.Connecting',
    [SpeakerStatus.NotReady]: 'Speaker.Status.NotReady',
    [SpeakerStatus.Ready]: 'Speaker.Status.Ready',
    [SpeakerStatus.GoingLive]: 'Speaker.Status.GoingLive',
    [SpeakerStatus.OnAir]: 'Speaker.Status.OnAir',
    [SpeakerStatus.Error]: 'Speaker.Status.Error',
    [SpeakerStatus.Banned]: 'Speaker.Status.Banned'
};

const STATUS_DOT_CLASSNAMES: Record<SpeakerStatus, string> = {
    [SpeakerStatus.Offline]: 'bg-gray-400',
    [SpeakerStatus.SettingUp]: 'bg-info',
    [SpeakerStatus.AwaitingAdmission]: 'bg-info',
    [SpeakerStatus.Connecting]: 'bg-info',
    [SpeakerStatus.NotReady]: 'bg-gray-400',
    [SpeakerStatus.Ready]: 'bg-success',
    [SpeakerStatus.GoingLive]: 'bg-success',
    [SpeakerStatus.OnAir]: 'bg-success',
    [SpeakerStatus.Error]: 'bg-warning',
    [SpeakerStatus.Banned]: 'bg-warning'
};

export const SpeakerStatusBadge = ({ status }: { status: SpeakerStatus }) => {
    const { t } = useTranslation();

    return (
        <span className="inline-flex items-center gap-1.5 text-xs text-gray-500 whitespace-nowrap">
            <span className={`inline-block w-2 h-2 rounded-full ${STATUS_DOT_CLASSNAMES[status]}`} aria-hidden="true" />
            {t(STATUS_LABEL_KEYS[status])}
        </span>
    );
};
